import InputView from "shared/controls/input_view";
import EditableTextInputView from "shared/controls/editable_text_input_view";
import EditableSelectInputView from "shared/controls/editable_select_input_view";
import Button from "shared/controls/button";

import Backdraft from "backdraft-app/src/backdraft";

Backdraft.plugin("Controls", function(plugin) {
  plugin.exports({
    InputView,
    EditableTextInputView,
    EditableSelectInputView,
    Button
  });
});
